module.exports = __webpack_public_path__ + "static/elephantwrap-f32dceeb5fc4b4e0a4d3adce757cec1d.jpeg";